import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';

const initSearchPageReactApp = () => {
    const reactAppWrapper = document.querySelector('#react-search-component-root');

    // Don't run on a non-React page
    if (reactAppWrapper !== null) {
        const reactAppSuggestionsUrl = reactAppWrapper.getAttribute('data-suggestions-url') || '';

        const reactAppSearchUrl = reactAppWrapper.getAttribute('data-search-url') || '';

        const reactAppLookupUrl = reactAppWrapper.getAttribute('data-lookup-url') || '';

        const reactAppTitle = reactAppWrapper.getAttribute('data-search-title') || '';

        const reactAppInputHint = reactAppWrapper.getAttribute('data-input-hint-text') || '';

        const reactAppInputLabel = reactAppWrapper.getAttribute('data-input-label-text') || '';

        const reactAppInputPlaceholder = reactAppWrapper.getAttribute('data-input-placeholder-text') || '';

        const reactAppResultSummaryPath = reactAppWrapper.getAttribute('data-result-summary-path') || '';

        const reactAppResultSummaryTruncation = reactAppWrapper.getAttribute('data-result-summary-truncation') || '';

        const summaryTruncationValue = parseInt(reactAppResultSummaryTruncation, 10);
        let summaryContentTruncation = 0;

        if ( !isNaN(summaryTruncationValue) ) {
          summaryContentTruncation = summaryTruncationValue;
        }

        const reactAppHighlightedTerms = reactAppWrapper.getAttribute('data-show-highlighted-terms') || '';

        let showHighlightedTerms = false;

        if (reactAppHighlightedTerms === 'true') {
          showHighlightedTerms = true;
        }

        const reactAppRecentSearches = reactAppWrapper.getAttribute('data-show-recent-searches') || '';

        let showRecentSearches = false;

        if (reactAppRecentSearches === 'true') {
            showRecentSearches = true;
        }

        const reactAppPageType = (reactAppWrapper.getAttribute('data-search-page-type') as SearchType) || 'global';

        const root = createRoot(reactAppWrapper);

        root.render(
            <React.StrictMode>
                <App
                    inputHintText={reactAppInputHint}
                    inputLabelText={reactAppInputLabel}
                    inputPlaceholderText={reactAppInputPlaceholder}
                    lookupUrl={reactAppLookupUrl}
                    searchPageType={reactAppPageType}
                    searchUrl={reactAppSearchUrl}
                    showHighlightedTerms={showHighlightedTerms}
                    showRecentSearches={showRecentSearches}
                    suggestionsUrl={reactAppSuggestionsUrl}
                    summaryContentTruncation={summaryContentTruncation}
                    summaryContentPath={reactAppResultSummaryPath}
                    title={reactAppTitle}
                    />
            </React.StrictMode>,
        );
    }
};

initSearchPageReactApp();
